import { useIntl } from 'react-intl';

import { Ppv } from '@kaltura-ott/tvpil-shared';

import { COMPONENT_NAME } from 'components/pages/VideoDetails/constants';
import { resolveMinutesToHours } from 'utils';

export function useResolvedRent() {
  const intl = useIntl();

  function resolveRent(rent: Ppv) {
    const {
      viewLifeCycle,
      price: { amount, currency },
    } = rent?.data;

    const rentDuration = resolveMinutesToHours(viewLifeCycle);
    const duration = intl.formatMessage(
      {
        defaultMessage: '{duration, plural, one {Rent for # hour} other {Rent for # hours}}',
        id: `${COMPONENT_NAME}.VideoContent.RentButton.duration.${intl.formatPlural(rentDuration)}`,
      },
      { duration: rentDuration },
    );

    const price = intl.formatNumber(amount, { style: 'currency', currency, minimumFractionDigits: 0 })

    return {
      duration,
      price,
      viewLifeCycle: rentDuration,
    };
  }

  return { resolveRent };
}
